import { Result } from '../../../../../common/models/Result';
import { HttpServiceBase } from '../../../../../common/services/HttpServiceBase';
import { Reward } from '../../../../models/Reward';

export class GetMembershipLevelRewardListService extends HttpServiceBase {

  handle = (id: number, bearerToken: string): Promise<Result<GetMembershipLevelRewardListOutput> | null> => {
    const promise = this.http.get<Result<GetMembershipLevelRewardListOutput>>(
      `${this.baseUrlZerezesApi}/club-pdv/membership-level/${id}/rewards`,
      bearerToken
    );
    return promise;
  }
}

export class GetMembershipLevelRewardListOutput {
  rewards?: Reward[];
}